import "client-only";

import type { LoginRequest } from "@/contracts/auth";
import { client } from "@/lib/platform/client";

const APP_NAME = "dashboard" as const;

async function login({ appKey }: LoginRequest): Promise<void> {
  await client.post("/api/auth/login", {
    appName: APP_NAME,
    appKey,
    authMode: "Cookie",
  });
}

async function checkSession(): Promise<void> {
  await client.get("/api/auth/session");
}

async function logout(): Promise<void> {
  await client.post("/api/auth/logout");
}

export const auth = { checkSession, login, logout };
